function isPresent(value) {
  if (value === undefined || value === null || value === "") {
    return false
  }
  if (typeof value === "object") {
    if (Array.isArray(value)) {
      return value.length > 0
    }
    return Object.keys(value).length > 0
  }
  return true
}

export function hasCustomEventDetail(event) {
  if (!event) {
    return false
  }
  if (event.success === false) {
    return true
  }
  const params = event.params ? event.params : {}
  if (params.scriptName) {
    return true
  }
  if (isPresent(params.metadata)) {
    return true
  }
  if (isPresent(params.output)) {
    return true
  }
  if (isPresent(params.logs) || isPresent(params.customLogs)) {
    return true
  }
  return false
}
